/*
 *描述：单选框
 *作者：bai.zhiming
 *时间：2017-6-16
 */
"use strict";
angular.module("trsRadioModule", []).directive("trsRadio", function() {
    return {
        restrict: "E",
        replace: false,
        templateUrl: "./utils/radio/radio_tpl.html",
        scope: {
            group: "@",
            ischecked: "=",
            label: "@",
            imgurl: "@",
            callback: "&",
            disabled: "="
        },
        link: function(scope, element, attrs, controller) {
            scope.imgurl = scope.imgurl || null;
            scope.toggleStatus = function() {
                if (!scope.disabled) {
                    if (typeof scope.callback) {
                        scope.callback();
                    }
                }
            };
        }
    };
});
